// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import Img from '../assets/logo.png'; // Adjust the path to your logo image

// const SignIn = ({ onClose, onGetOtpClick }) => {
//   // Function to stop the event from propagating to the parent element
//   const handleContentClick = (event) => {
//     event.stopPropagation();
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
//       onClick={onClose} // Close modal when clicking outside the content
//     >
//       <div
//         className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-[324px]"
//         onClick={handleContentClick} // Prevent closing when clicking inside the content
//       >
//         <div className="relative mb-4">
//           <img
//             src={Img}
//             alt="Img Maali Logo"
//             className=" h-[82px]"
//           />
//           <button
//             onClick={onClose}
//             className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
//           >
//             <FontAwesomeIcon icon={faTimes} />
//           </button>
//         </div>
//         <h2 className="text-center text-lg font-semibold mb-4">
//           Welcome to MoveOnWheels
//         </h2>
//         <div className="mb-4">
//           <label
//             htmlFor="mobile"
//             className="block text-sm font-medium text-gray-700 mb-2 text-left"
//           >
//             Enter Your Mobile Number
//           </label>
//           <input
//             type="text"
//             id="mobile"
//             placeholder="+91 9591621445"
//             className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
//           />
//         </div>
//         <button
//           className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//           onClick={onGetOtpClick}
//         >
//           Get OTP
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SignIn;

// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import Img from '../assets/logo.png'; // Adjust the path to your logo image

// const SignIn = ({ onClose, onGetOtpClick }) => {
//   // Function to stop the event from propagating to the parent element
//   const handleContentClick = (event) => {
//     event.stopPropagation();
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
//       onClick={onClose} // Close modal when clicking outside the content
//     >
//       <div
//         className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-auto"
//         onClick={handleContentClick} // Prevent closing when clicking inside the content
//       >
//         <div className="relative mb-4 flex justify-center items-center">
//           <img
//             src={Img}
//             alt="Img Maali Logo"
//             className="h-[82px]"
//           />
//           <button
//             onClick={onClose}
//             className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
//           >
//             <FontAwesomeIcon icon={faTimes} />
//           </button>
//         </div>
//         <h2 className="text-center text-lg font-semibold mb-4">
//           Welcome to MoveOnWheels
//         </h2>
//         <h2 className="text-center text-lg font-semibold text-[#FF9630] mb-4">
//           Rent. Get. Go.
//         </h2>
//         <div className="mb-4">
//           <label
//             htmlFor="mobile"
//             className="block text-sm font-medium text-gray-700 mb-2 text-left"
//           >
//             Enter Your Mobile Number
//           </label>
//           <input
//             type="text"
//             id="mobile"
//             placeholder="+91 9591621445"
//             className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
//           />
//         </div>
//         <button
//           className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//           onClick={onGetOtpClick}
//         >
//           Get OTP
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SignIn;


// import React from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import { useNavigate } from "react-router-dom"; // Import useNavigate
// import Img from '../assets/logo.png'; // Adjust the path to your logo image

// const SignIn = ({ onClose }) => {
//   const navigate = useNavigate(); // Initialize navigation hook

//   // Function to handle OTP button click
//   const handleGetOtpClick = () => {
//     navigate("/verify"); // Navigate to the "Verify" page
//   };

//   // Function to stop the event from propagating to the parent element
//   const handleContentClick = (event) => {
//     event.stopPropagation();
//   };

//   return (
//     <div
//       className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
//       onClick={onClose} // Close modal when clicking outside the content
//     >
//       <div
//         className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-auto"
//         onClick={handleContentClick} // Prevent closing when clicking inside the content
//       >
//         <div className="relative mb-4 flex justify-center items-center">
//           <img
//             src={Img}
//             alt="Img Maali Logo"
//             className="h-[82px]"
//           />
//           <button
//             onClick={onClose}
//             className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
//           >
//             <FontAwesomeIcon icon={faTimes} />
//           </button>
//         </div>
//         <h2 className="text-center text-lg font-semibold mb-4">
//           Welcome to MoveOnWheels
//         </h2>
//         <h2 className="text-center text-lg font-semibold text-[#FF9630] mb-4">
//           Rent. Get. Go.
//         </h2>
//         <div className="mb-4">
//           <label
//             htmlFor="mobile"
//             className="block text-sm font-medium text-gray-700 mb-2 text-left"
//           >
//             Enter Your Mobile Number
//           </label>
//           <input
//             type="text"
//             id="mobile"
//             placeholder="+91 9591621445"
//             className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
//           />
//         </div>
//         <button
//           className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
//           onClick={handleGetOtpClick} // Call handleGetOtpClick on click
//         >
//           Get OTP
//         </button>
//       </div>
//     </div>
//   );
// };

// export default SignIn;

import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import Img from "../assets/logo.png"; // Adjust the path to your logo image

const SignIn = ({ onClose }) => {
  const navigate = useNavigate(); // Initialize navigation hook

  // Dummy dataset
  const dummyData = {
    mobile: "+91 9591621445",
  };

  // State for form data
  const [formData, setFormData] = useState({
    mobile: dummyData.mobile, // Initialize with dummy data
  });

  // Function to handle OTP button click
  const handleGetOtpClick = () => {
    navigate("/verify"); // Navigate to the "Verify" page
  };

  // Function to stop the event from propagating to the parent element
  const handleContentClick = (event) => {
    event.stopPropagation();
  };

  // Function to handle input changes
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  // Function to handle form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();
    const formSubmitData = new FormData();
    formSubmitData.append("mobile", formData.mobile);

    // Log FormData keys and values for demonstration
    for (const [key, value] of formSubmitData.entries()) {
      console.log(`${key}: ${value}`);
    }

    // You can send the formSubmitData to a backend here
    handleGetOtpClick(); // Navigate after submission
  };

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
      onClick={onClose} // Close modal when clicking outside the content
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-[350px] h-auto"
        onClick={handleContentClick} // Prevent closing when clicking inside the content
      >
        <div className="relative mb-4 flex justify-center items-center">
          <img src={Img} alt="Img Maali Logo" className="h-[82px]" />
          <button
            onClick={onClose}
            className="absolute top-0 right-0 text-gray-500 hover:text-gray-700"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        <h2 className="text-center text-lg font-semibold mb-4">
          Welcome to MoveOnWheels
        </h2>
        <h2 className="text-center text-lg font-semibold text-[#FF9630] mb-4">
          Rent. Get. Go.
        </h2>
        <form onSubmit={handleFormSubmit}>
          <div className="mb-4">
            <label
              htmlFor="mobile"
              className="block text-sm font-medium text-gray-700 mb-2 text-left"
            >
              Enter Your Mobile Number
            </label>
            <input
              type="text"
              id="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
              placeholder="+91 9591621445"
              className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <button
            type="submit"
            className="w-full bg-[#FF9630] text-white py-2 rounded-md hover:bg-[#FF9630]"
          >
            Get OTP
          </button>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
